import connectToStores from 'alt-utils/lib/connectToStores'
import { SERPPreviewActions } from 'actions'
import { SERPPreviewStore } from 'stores'
import Helmet from 'react-helmet'
import { SERPPreview, Loading } from 'components'
import { ResponsiveDialog } from 'common-frontend'

@connectToStores
export default class SERPPreviewContainer extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired
  }
  static propTypes = {
    params: React.PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
  }

  componentWillMount() {
    SERPPreviewActions.fetch(this.props.location.query.u)
  }

  static getStores() {
    return [SERPPreviewStore]
  }

  static getPropsFromStores() {
    return SERPPreviewStore.getState()
  }

  render() {
    let previews = <Loading />
    if (this.props.previews !== null) {
      previews = []
      for (let preview of this.props.previews) {
        previews.push(
          <SERPPreview key={preview.url} expanded={true} {...preview} />
        )
      }
    }

    return (
      <ResponsiveDialog open={true} maxWidth='700px'>
        <h2 className="large-spacing--top">Live Search engine preview</h2>
        {this.props.location.query.u}
        <div style={{ marginTop: '20px' }}>
          {previews}
        </div>
      </ResponsiveDialog>
    )
  }
}



// WEBPACK FOOTER //
// ./app/containers/SERPPreviewContainer.js